import { APICallV3Post } from 'reactApp/api/APICall';
import { TWopi } from 'reactApp/api/wopi/WopiAPI.types';

export class WopiViewAPICall extends APICallV3Post<TWopi> {
    _method = 'wopi-go/view';
}

export class WopiEmbeddedViewAPICall extends APICallV3Post<TWopi> {
    _method = 'wopi-go/embedded/view_direct';
}
